import { memo } from 'react';
import { Page } from '@bonanza-social/navigation';
import AccountMFA from '../components/AccountMFA/AccountMFA';
import React from 'react';
import { Box } from '@bonanza-social/moonlight';

function AccountMFAModal() {
  return (
    <Page>
      <Box width="100%">
        <AccountMFA />
      </Box>
    </Page>
  );
}

export default memo(AccountMFAModal);
